"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _pclnDesignSystem = require("pcln-design-system");

var _Caption = _interopRequireDefault(require("../../text/Caption"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Container = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "ap9u94-0"
})(["width:fit-content;box-shadow:0 0 0 1px ", ";cursor:pointer;"], (0, _pclnDesignSystem.getPaletteColor)('border.base'));

function Chip(_ref) {
  var className = _ref.className,
      isActive = _ref.isActive,
      iconName = _ref.iconName,
      label = _ref.label,
      color = _ref.color,
      onClick = _ref.onClick,
      onClose = _ref.onClose;
  var bg = isActive ? null : 'background.lightest';
  return _react["default"].createElement(Container, {
    className: className,
    color: color,
    bg: bg,
    alignItems: "center",
    py: 2,
    px: 3,
    onClick: onClick
  }, _react["default"].createElement(_pclnDesignSystem.Icon, {
    name: iconName,
    size: 16,
    mr: 1
  }), _react["default"].createElement(_Caption["default"], null, label), onClose && _react["default"].createElement(_pclnDesignSystem.CloseButton, {
    size: 16,
    ml: 1,
    onClick: onClose
  }));
}

Chip.displayName = 'Chip';
Chip.propTypes = {
  className: _propTypes["default"].string,
  isActive: _propTypes["default"].bool,
  iconName: _propTypes["default"].string,
  label: _propTypes["default"].string,
  color: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  onClose: _propTypes["default"].func
};
Chip.defaultProps = {
  className: '',
  color: 'primary'
};

var _default = (0, _react.memo)(Chip);

exports["default"] = _default;